import { ApiProvider } from "@src/store/ApiProvider";

const FALLBACK_PORTAL_ASSET_HOST = "https://portal_qa.stagefront.com";

export const getPortalAssetHost = (): string => (ApiProvider.default?.baseURL || FALLBACK_PORTAL_ASSET_HOST).replace(/\/+$/, "");

export const buildPortalAssetUrl = (path: string): string => `${getPortalAssetHost()}/${String(path).replace(/^\/+/, "")}`;
